(function () {
  'use strict';

  var HOLIDAYS = ['25-12-2025','26-12-2025','01-01-2026','27-04-2026','05-05-2026'];
  var SECTION_ID = 'cart-delivery-data';

  var map = {};
  var refetchPending = null;
  var upcartRoot = null;
  var shadowObserver = null;
  var injectTimer = null;

  function parseInlineMap() {
    var el = document.getElementById('vfs-delivery-map');
    if (!el) return {};
    try { return JSON.parse(el.textContent.trim()); } catch (e) { return {}; }
  }

  function fmtDate(d) {
    var dd = String(d.getDate()).padStart(2, '0');
    var mm = String(d.getMonth() + 1).padStart(2, '0');
    return dd + '-' + mm + '-' + d.getFullYear();
  }

  function calcDate(days) {
    var d = new Date();
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && HOLIDAYS.indexOf(fmtDate(d)) === -1) added++;
    }
    return d;
  }

  function formatDelivery(target) {
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var t = new Date(target);
    t.setHours(0, 0, 0, 0);
    var diff = Math.round((t - today) / 86400000);

    var dateLabel = t.getDate() + ' ' + t.toLocaleDateString('nl-NL', { month: 'long' });
    var relative = null;
    if (diff <= 0) relative = 'vandaag';
    else if (diff === 1) relative = 'morgen';
    else if (diff < 7) relative = t.toLocaleDateString('nl-NL', { weekday: 'long' });

    if (relative) {
      return 'Ontvang het <strong>' + relative + '</strong>, ' + dateLabel;
    }
    return 'Ontvang het op <strong>' + dateLabel + '</strong>';
  }

  function refetch() {
    if (refetchPending) return refetchPending;
    refetchPending = fetch('/?sections=' + SECTION_ID, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[SECTION_ID] || '';
        var m = html.match(/<script[^>]*id=["']vfs-delivery-map["'][^>]*>([\s\S]*?)<\/script>/);
        if (m && m[1]) {
          try { map = JSON.parse(m[1].trim()); } catch (e) {}
        }
        refetchPending = null;
        inject();
      })
      .catch(function () { refetchPending = null; });
    return refetchPending;
  }

  function getVariantId(item) {
    var link = item.querySelector('a[href*="variant="]');
    if (link) {
      var m = link.getAttribute('href').match(/variant=(\d+)/);
      if (m) return m[1];
    }
    var input = item.querySelector('input[name="id"],input[name*="variant"]');
    if (input && /^\d+$/.test(input.value)) return input.value;
    return null;
  }

  function inject() {
    if (!upcartRoot) return;
    var items = upcartRoot.querySelectorAll('li.upcart-internal-cart-item');

    Array.prototype.forEach.call(items, function (item) {
      var existing = item.querySelector('.vfs-delivery');
      var vid = getVariantId(item);

      if (!vid || !map[vid]) {
        if (existing) existing.remove();
        return;
      }

      var days = map[vid];
      var html = formatDelivery(calcDate(days));

      if (existing) {
        if (existing.dataset.days === String(days)) return;
        existing.innerHTML = html;
        existing.dataset.days = String(days);
        return;
      }

      var p = document.createElement('p');
      p.className = 'vfs-delivery';
      p.dataset.days = String(days);
      p.style.cssText = 'font-size:12px;line-height:1.3;margin:6px 0 0;color:#333;';
      p.innerHTML = html;

      var tile = item.querySelector('.upcart-internal-component-product-tile__info')
        || item.querySelector('.upcart-internal-component-product-tile__content')
        || item.querySelector('.upcart-internal-component-product-tile')
        || item;
      tile.appendChild(p);
    });
  }

  function attachShadowObserver() {
    if (shadowObserver || !upcartRoot) return;
    shadowObserver = new MutationObserver(function () {
      clearTimeout(injectTimer);
      injectTimer = setTimeout(inject, 120);
    });
    shadowObserver.observe(upcartRoot, { childList: true, subtree: true });
    inject();
  }

  function findUpcartRoot() {
    if (upcartRoot) return true;
    var host = document.getElementById('upCart');
    if (host && host.shadowRoot) {
      upcartRoot = host.shadowRoot;
      attachShadowObserver();
      return true;
    }
    return false;
  }

  function waitForUpcart() {
    if (findUpcartRoot()) return;
    var bodyObs = new MutationObserver(function () {
      if (findUpcartRoot()) bodyObs.disconnect();
    });
    bodyObs.observe(document.documentElement, { childList: true, subtree: true });
  }

  map = parseInlineMap();

  var origFetch = window.fetch;
  window.fetch = function () {
    var url = typeof arguments[0] === 'string'
      ? arguments[0]
      : (arguments[0] && arguments[0].url) || '';
    var isCartMutation = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
    var p = origFetch.apply(this, arguments);
    if (isCartMutation) {
      p.then(function () { setTimeout(refetch, 100); }, function () {});
    }
    return p;
  };

  var origXhrOpen = XMLHttpRequest.prototype.open;
  var origXhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__vfsUrl = url;
    return origXhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    var url = this.__vfsUrl || '';
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      this.addEventListener('load', function () { setTimeout(refetch, 100); });
    }
    return origXhrSend.apply(this, arguments);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForUpcart);
  } else {
    waitForUpcart();
  }
})();
